import { css } from 'styled-components';
import { BACKGROUND_COLOR, BORDER, BORDER_RADIUS } from '../tokens';
import { CFBaseAccordionTokens } from '..';
export const backgroundColor = ({ $panelActive, }) => BACKGROUND_COLOR[$panelActive ? 'ACTIVE' : 'DEFAULT'];
export const dividerPosition = ({ $fullWidth, $position, }) => {
    return css `
    left: ${$fullWidth ? 0 : CFBaseAccordionTokens.PADDING.INLINE}px;
    right: ${$fullWidth ? 0 : CFBaseAccordionTokens.PADDING.INLINE}px;
    ${$position === 'top'
        ? css `
          top: 0;
        `
        : css `
          bottom: 0;
        `};
  `;
};
export const rootBorder = ({ $bordered, $fullWidth, }) => {
    if (!$bordered)
        return null;
    return $fullWidth
        ? css `
        border: ${BORDER};
        border-radius: 0;
      `
        : css `
        border: ${BORDER};
        border-radius: ${BORDER_RADIUS.ROOT}px;
      `;
};
export const rootSizeNative = ({ $extendIntoGutters, }) => {
    return $extendIntoGutters
        ? css `
        margin-left: -${CFBaseAccordionTokens.PADDING.INLINE}px;
        margin-right: -${CFBaseAccordionTokens.PADDING.INLINE}px;
      `
        : css `
        width: 100%;
      `;
};
export const rootSizeWeb = ({ $extendIntoGutters, }) => {
    return $extendIntoGutters
        ? css `
        margin-left: -${CFBaseAccordionTokens.PADDING.INLINE}px;
        margin-right: -${CFBaseAccordionTokens.PADDING.INLINE}px;
        width: calc(100% + 2 * ${CFBaseAccordionTokens.PADDING.INLINE}px);
      `
        : css `
        width: 100%;
      `;
};
